import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { translateTAValue } from 'src/app/system-utils/pipes/translateTA';
import { ChamadoNovoComponent } from './chamado-novo.component';

/**
 * Abre o formulário de chamado num modal central.
 *
 * Uma função, e não a configuração repetida em cada chamador: o balão
 * flutuante (shell) e a tela de acompanhamento (módulo lazy) abrem o MESMO
 * modal, e duas cópias da configuração sairiam de sincronia na primeira
 * mudança de largura ou de título.
 *
 * O `afterClose` entrega `{ ticketId, numero }` quando algum chamado foi
 * aberto, ou `undefined` quando a pessoa só fechou — é assim que quem chamou
 * decide se recarrega a lista.
 */
export function abrirModalDeChamado(modal: NzModalService, translate: TranslateService,
    origem?: { ticketId: string, numero: string }): NzModalRef {

    return modal.create({
        nzTitle: translateTAValue(translate, 'tkt.novo.titulo'),
        nzContent: ChamadoNovoComponent,
        // Sem rodapé do modal: o componente tem os próprios botões, que
        // mudam depois de o chamado ser aberto (abrir outro / ver meus).
        nzFooter: null,
        nzWidth: 640,
        nzCentered: true,
        // Fechar clicando fora perderia um texto longo já digitado sem
        // perguntar nada — e a descrição é justamente o campo caro desta tela.
        nzMaskClosable: false,
        // De qual chamado este novo e continuacao. Chega como @Input no
        // componente e volta no `open`, para o historico nao se partir.
        nzData: origem ?? null,
    });
}
